module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "outlook-header.b0bf42e1.svg";